import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: '[itemBoxState]',
})
export class ItemBoxStateDirective implements OnInit {
  private idsSet = new Set();

  constructor(private elementRef: ElementRef<HTMLElement>) {}
 
  ngOnInit(): void {
    (this.elementRef.nativeElement as any).itemBoxStateInstance = this;
  }

  isExpanded(id: any): boolean {
    return this.idsSet.has(this.createKey(id));
  }

  setExpanded(id: any): void {
    this.idsSet.add(this.createKey(id));
  }

  setCollapsed(id: any): void {
    this.idsSet.delete(this.createKey(id));
  }

  private createKey(id: any): string {
    return `${id}`;
  }
}
